const initialState = { friends: [] };

const friendListReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_FRIEND':
      return {
        ...state,
        friends: [...state.friends, action.payload.friend],
      };
    default:
      return state;
  }
};

export default friendListReducer;